import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Chip,
  Avatar,
} from '@mui/material'
import React, { useRef } from 'react'
import { getCategories } from '../../utils/common'
import AudioPlayer from '../../components/UploadAudio/AudioPlayer'

const ViewAudioModal = ({
  openDialog,
  handleCloseDialog,
  classes,
  selectedAudio,
}) => {
  const audioRef = useRef(new Audio(selectedAudio?.uri))

  const handleCloseDialogHandler = () => {
    if (audioRef.current) {
      audioRef.current.pause()
      audioRef.current.currentTime = 0
    }
    handleCloseDialog()
  }

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialogHandler}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          width: '80%',
          maxWidth: '400px',
        },
      }}
    >
      <DialogTitle style={{ fontSize: '20px', width: '200px', color: 'black' }}>
        Audio Details
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ fontSize: '18px' }}>
          Title: <span style={{ fontWeight: 400 }}>{selectedAudio?.name}</span>
        </Typography>
        <Typography variant="body1" sx={{ fontSize: '18px', mb: 1 }}>
          Categories:
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
          {selectedAudio?.categories?.map((category) => (
            <Chip
              key={category._id}
              label={`${category.name} - ${category.status ?? 'INACTIVE'}`}
              color={category.status === 'ACTIVE' ? 'success' : 'default'}
              sx={{
                mb: 1,
                backgroundColor:
                  category.status === 'ACTIVE' ? '#4CAF50' : 'default',
                color: category.status === 'ACTIVE' ? 'white' : 'default',
              }}
            />
          ))}
        </Box>
        {selectedAudio?.contests?.length > 0 && (
          <>
            <Typography variant="body1" sx={{ fontSize: '18px', mb: 1 }}>
              Contests:
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
              {selectedAudio?.contests?.map((contest) => (
                <Chip
                  key={contest._id}
                  avatar={<Avatar src={contest.logo} />}
                  label={contest.title}
                  sx={{
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    '& .MuiChip-label': {
                      fontSize: '12px',
                      padding: '0 12px',
                    },
                  }}
                />
              ))}
            </Box>
          </>
        )}
        <Typography variant="body1" sx={{ fontSize: '18px' }}>
          Thumbnail:
        </Typography>
        <Box>
          <img
            src={selectedAudio?.image}
            alt="Category Logo"
            style={{
              maxWidth: '100px',
              maxHeight: '100px',
              objectFit: 'contain',
            }}
          />
        </Box>
        <Typography
          variant="body1"
          sx={{ fontSize: '18px', marginTop: '16px' }}
        >
          Audio Source:
        </Typography>
        <Box sx={{ mt: 1 }}>
          <AudioPlayer audioRef={audioRef} openDialog={openDialog} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialogHandler}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ViewAudioModal
